// import { divide } from "lodash"
import React, { useEffect, useState } from "react"
import ProductGrid from "../../ProductGrid/ProductGrid"
import * as styles from "./articles.module.scss"
import { Link } from "gatsby";
import { useLocale, useLocalPath } from "../../../../hooks";

const newArticleArray = articles => {
    let newArray = []
    let gridItems = []
    // converting array of single article objects to an array of arrays consisting of two or one article objects
    // to send to product grid component which requires an array of two or one articles objects.
    articles.sectionThumbnail?.forEach((article, index) => {
        if (articles.sectionThumbnail.length % 2 == 0) {
            if ((index + 1) % 2 == 0) {
                gridItems.push([
                    articles.sectionThumbnail[index - 1],
                    articles.sectionThumbnail[index],
                ])
                newArray.push(gridItems)
            } else null
        } else {
            if (index + 1 == articles.sectionThumbnail.length) {
                gridItems.push([articles.sectionThumbnail[index]])
                newArray.push(gridItems)
            } else if ((index + 1) % 2 == 0) {
                gridItems.push([
                    articles.sectionThumbnail[index - 1],
                    articles.sectionThumbnail[index],
                ])
                newArray.push(gridItems)
            } else null
        }
    })
    return newArray
}

const Articles = ({ articles }) => {
    const [articlesArr, setArticlesArr] = useState(newArticleArray(articles))
    const locale = useLocale()

    return (
        <div className={styles.articles_container}>
            {articles.title && locale !== "tr-TR" &&
                <h2 className="yellow_border">{articles.title}</h2>
            }

            {(articles.title && locale === "tr-TR") &&
                // <Link to={useLocalPath(`/${articles.slug}`)}>
                //     </Link>
                    <h2 className="yellow_border">{articles.title}</h2>
                
            }

            {(articles.heading && locale === "en-US") &&
                <h2 className="yellow_border">{articles.heading}</h2>
            }

            <div className={styles.articles}>
                {articlesArr[0]?.map((articlePair, index) => {
                    if ((index + 1) % 2 !== 0) {
                        return (
                            <ProductGrid
                                key={index}
                                gridArrayData={articlePair}
                                widthLeft="30%"
                                widthRight="70%"
                                gridArrayIcon={articles?.icon?.fluid}
                                gridArrayWholeIcon={articles.icon}
                            />
                        )
                    } else {
                        return (
                            <ProductGrid
                                key={index}
                                gridArrayData={articlePair}
                                widthLeft="70%"
                                widthRight="30%"
                                gridArrayWholeIcon={articles.icon}
                                gridArrayIcon={articles?.icon?.fluid}
                            />
                        )
                    }
                })}
            </div>
        </div>
    )
}

export default Articles
